import isNil from 'lodash/isNil';
import isElement from 'lodash/isElement';

export function isFooterOverflownBy(element) {
    const footerBottomElement = document.getElementsByClassName('page-footer')?.[0];
    if (!isElement(footerBottomElement) || !isElement(element)) {
        return false;
    }
    const footerBottomPosition = footerBottomElement.getBoundingClientRect()?.bottom;
    const elementBottomPosition = element.getBoundingClientRect()?.bottom;
    return elementBottomPosition > footerBottomPosition;
}

export function doesElementExceedWindowBottom(element) {
    if (!isElement(element)) {
        return false;
    }
    const windowBottomPosition = window.innerHeight;
    const elementBottomPosition = element.getBoundingClientRect()?.bottom;
    return elementBottomPosition > windowBottomPosition;
}

export function setElementHeightBasedOnWindowEnd(element, minHeight) {
    if (!isElement(element) || isNil(minHeight)) {
        return false;
    }
    const elementTopPosition = element.getBoundingClientRect()?.top;
    const elementPaddingTop = parseFloat(window.getComputedStyle(element).getPropertyValue('padding-top'));
    const elementPaddingBottom = parseFloat(window.getComputedStyle(element).getPropertyValue('padding-bottom'));
    const elementAdditionalHeight = elementPaddingTop + elementPaddingBottom;
    const marginBottomInPx = 20;
    const calcHeight = window.innerHeight - elementTopPosition - elementAdditionalHeight - marginBottomInPx;
    return calcHeight > minHeight ? calcHeight : minHeight;
}

export function isDropdownNextToFooter(element) {
    const highestPossibleMarginBetweenElements = 250; //TODO: used to check if dropdown is close to the footer; find a better solution, because it's vulnerable to DOM changes
    const footerElement = document.getElementsByClassName('page-footer')?.[0];
    if (!isElement(footerElement) || !isElement(element)) {
        return false;
    }
    const footerTopPosition = footerElement.getBoundingClientRect().top;
    const elementBottomPosition = element.getBoundingClientRect().bottom;
    return footerTopPosition - elementBottomPosition < highestPossibleMarginBetweenElements;
}
